import { DocumentGroupTypeCode, ProgramDocument } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getStaffProgramDocuments: (
  fetchContext: FetchContext,
  documentGroupTypeCode: DocumentGroupTypeCode,
  accessToken?: string,
) => Promise<ProgramDocument[]> = (fetchContext, documentGroupTypeCode, accessToken) => {
  const searchParams = new URLSearchParams();
  searchParams.append('documentGroupTypeCode', documentGroupTypeCode);

  const url = `${fetchContext.baseUrl}/api/staff/program-documents${
    searchParams.size > 0 ? `?${searchParams}` : ''
  }`;

  return fetch(url,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<ProgramDocument[]>(fetchContext.errorStore, response, 'get staff program documents'));
};
